<script setup>
  import { ref, watch, onMounted, defineAsyncComponent } from 'vue';
  import DataContainer from "@/components/DataContainer.vue";
  import GorgeWindbow from '@/components/GorgeWindbow.vue';
  import SegmentedControl from "@/components/controls/SegmentedControl.vue";
  import SegmentedControlButton from "@/components/controls/SegmentedControlButton.vue";  

  const GorgeWindbowUpgradeBlock = defineAsyncComponent(() => import('@/components/GorgeWindbowUpgradeBlock.vue')); 

  const emit = defineEmits(['containerSettings:change']);
  const windbow = defineModel('content');

  const props = defineProps({
    containerSettings: {
      type: Object,
      required: false
    },    
    upgrade: {
      type: Array,
      required: true
    }
  });  

  const windbowViewType = ref('windbow');

  function getSettings() {
    return {
      windbowViewType: windbowViewType.value
    };
  }

  function emitSettingsChange() {
    emit('containerSettings:change');      
  }

  watch(windbowViewType, (newValue) => {
    if (!windbow.value) return;

    windbow.value.changeViewType(newValue);
    emitSettingsChange();
  }); 

  onMounted(() => {
    if (props.containerSettings && Object.keys(props.containerSettings).length > 0) {
      windbowViewType.value = props.containerSettings.windbowViewType;
    }; 
  });

  defineExpose({ getSettings });
</script>

<template>
  <DataContainer v-if="props.upgrade[3] < 46" style="width: 100%; height: 100%; flex: 1;">
    <GorgeWindbowUpgradeBlock
      :upgrade="props.upgrade"
    />
  </DataContainer>
  <DataContainer v-else style="width: 100%; height: 100%; flex: 1;">
    <div
      class="jwx-data-container__toolbar"
      ref="toolbarContainer"
    >
      <SegmentedControl
        v-model="windbowViewType"
        label="Select how you would like to view the Gorge Winbow data."
        style="--segmented-control-background-color: hsl(360, 100%, 100%); min-width: 160px;"
      >
        <SegmentedControlButton value="windbow">Windbow</SegmentedControlButton>
        <SegmentedControlButton value="gradient">Gradient</SegmentedControlButton>
      </SegmentedControl>

    </div>

    <GorgeWindbow
      v-model="windbow"
      v-model:viewType="windbowViewType"
     />
  </DataContainer>
</template>